import { useCallback, useState } from 'react'
import { VerticalSortItem } from '../../../../../../../../baseComponents/Sorts/VerticalSortList/types'
import { OnSubmit } from '../../../../../../../../forms/TwinForm/types'
import { twinFetchPostJSON } from '../../../../../../../../utils/globals/data'
import { getEmployeeQuickAccessParam } from '../../../../../../../../utils/reducers/getters'
import { changeEmployeeParams } from '../../../../../../../../utils/reducers/reduxDispatch'
import { ButtonModalSortListStateLess } from '../../../../../../../../baseComponents/Sorts/ButtonModalSortList'

interface ModalSortEmployeeQAProps extends ModalSortEmployeeQALogicProps {}

const ModalSortEmployeeQA: React.FC<ModalSortEmployeeQAProps> = ({ ...rest }) => {
    const { getData, ...logic } = useModalSortEmployeeQALogic({ ...rest })
    return (
        <ButtonModalSortListStateLess {...logic} userPermissions={{ n: 4, permission: 'delete' }} onOpen={getData}/>
    )
}

interface ModalSortEmployeeQALogicProps {
    onSubmit: OnSubmit
}

const useModalSortEmployeeQALogic = ({ onSubmit }: ModalSortEmployeeQALogicProps) => {
    const [data, setData] = useState<VerticalSortItem[] | null>(null)

    const getData = useCallback(() => {
        setData(getEmployeeQuickAccessParam())
    }, [])

    const updateOrder = useCallback(async () => {
        const dataStr = JSON.stringify(data)
        const result = await twinFetchPostJSON('/api/app/config/employee/updateEmployeeParameter', { parameterKey: 'employee_quick_access', value: dataStr })
        changeEmployeeParams({ 'employee_quick_access': dataStr })
        onSubmit(result, {})
    }, [onSubmit, data])
    return { data, setData, updateOrder, getData }
}

export default ModalSortEmployeeQA